import { ICustomerLinkedAccount } from './types/customers';

interface IIsLinkedAccountParams {
  linkedAccounts: ICustomerLinkedAccount[] | null;
  payerAccountId: string;
  linkedAccountId: string;
}

export function isLinkedAccount({ linkedAccounts, payerAccountId, linkedAccountId }: IIsLinkedAccountParams) {
  if (!linkedAccounts) {
    return false;
  }
  return linkedAccounts.some(
    (linkedAccount) =>
      linkedAccount.payerAccountId === payerAccountId &&
      linkedAccount.linked_account.id === linkedAccountId
  );
}
